
























import { InputSetups } from '@/mixins/input-setups'

import ToggleButton from 'piramis-base-components/src/components/ToggleButton.vue'

import { Component, Mixins, VModel } from 'vue-property-decorator'
import {
  PersonalChannelMembersCondition
} from "@/includes/logic/FaceControl/conditions/PersonalChannelMembersCondition/PersonalChannelMembersCondition";

@Component({
  components: {
    ToggleButton
  }
})
export default class PersonalChannelMembersView extends Mixins<InputSetups>(InputSetups) {
  @VModel() model!: PersonalChannelMembersCondition

  get mode() {
    return this.model.mode === "Greater"
  }

  set mode(state: boolean) {
    this.model.mode = state ? "Greater" : "Less"
  }
}
